var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2249 5.98538H8.23222V2.99268H6.73587V5.98538H3.74316V7.48173H6.73587V10.4744H8.23222V7.48173H11.2249V5.98538ZM3.74316 14.2153H11.2249V15.7117H3.74316V14.2153ZM3.74316 17.9562H11.2249V19.4526H3.74316V17.9562ZM14.2176 5.98538H21.6994V7.48173H14.2176V5.98538ZM19.0134 16.4598L21.6994 13.7739L20.6445 12.719L17.9585 15.4049L15.2726 12.719L14.2176 13.7739L16.9036 16.4598L14.2176 19.1458L15.2726 20.2007L17.9585 17.5148L20.6445 20.2007L21.6994 19.1458L19.0134 16.4598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculation);
export default __webpack_public_path__ + "static/media/calculation.f8d4c1650c019428ce8c8826a6fa0844.svg";
export { ForwardRef as ReactComponent };